import {
  LEADS_PAGE_PATH,
  SALES_FUNNELS_LEADS_PATH,
} from '@app/routes/pages/leadsPages/constants';

import type { LeadsViewMode } from '../ui/LeadsViewModeSwitcher';

export const LEADS_VIEW_MODE_OPTIONS: {
  value: LeadsViewMode;
  label: string;
}[] = [
  { value: 'registry', label: 'Реестр' },
  { value: 'funnels', label: 'Воронки' },
];

export const LEADS_VIEW_MODE_PATHS: Record<LeadsViewMode, string> = {
  registry: LEADS_PAGE_PATH,
  funnels: SALES_FUNNELS_LEADS_PATH,
};
